export default __webpack_public_path__ + "f999a2c0398aa630c7555604477843b6.svg";